<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <Ingreso_Proyectado />
      <Participacion_Contacto />
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card
          color="success"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-h3 font-Wweight-light">
              Cantidad de proyectos por etapa de negociación:
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headersDashCantidadEstadoNegociacion"
              :items="items"
            >
              <template v-slot:[`item.cantidadProyectos`]="{ item }">
                <h3><strong>{{ item.cantidadProyectos }}</strong></h3>
              </template>
              <template v-slot:[`item.eficacia`]="{ item }">
                <h3><strong>{{ computedEficacia(item.eficacia).toFixed(0) }}%</strong></h3>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card
          color="success"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-h3 font-Wweight-light">
              Totales en Soles, por etapa de negociación:
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headersDashIngresoEstadoNegociacion"
              :items="items"
            >
              <template v-slot:[`item.subtotal`]="{ item }">
                <h3><strong>S/. {{  Intl.NumberFormat().format(parseInt(item.totalMontoNegociacion) + parseInt(item.totalMontoGanado) + parseInt(item.totalMontoPerdido)) }}</strong></h3>
              </template>
              <template v-slot:[`item.totalMontoNegociacion`]="{ item }">
                S/. {{ new Intl.NumberFormat().format(item.totalMontoNegociacion) }}
              </template>
              <template v-slot:[`item.totalMontoGanado`]="{ item }">
                S/. {{ new Intl.NumberFormat().format(item.totalMontoGanado) }}
              </template>
              <template v-slot:[`item.totalMontoPerdido`]="{ item }">
                S/. {{ new Intl.NumberFormat().format(item.totalMontoPerdido) }}
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card
          color="warning"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-h3 font-weight-light">
              Ingreso estimado por Asesor:
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headersDashIngresoAsesor"
              :items="items"
            >
              <template v-slot:[`item.detalle`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDialogVerDetalle(item)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <template v-slot:[`item.subtotal`]="{ item }">
                <h3><strong>S/. {{ new Intl.NumberFormat().format(parseInt(item.totalMontopuertas) + parseInt(item.totalMontoCerraduras) + parseInt(item.totalMontoCortafuego)) }}</strong></h3>
              </template>
              <template v-slot:[`item.totalMontopuertas`]="{ item }">
                S/. {{ new Intl.NumberFormat().format(item.totalMontopuertas) }}
              </template>
              <template v-slot:[`item.totalMontoCerraduras`]="{ item }">
                S/. {{ new Intl.NumberFormat().format(item.totalMontoCerraduras) }}
              </template>
              <template v-slot:[`item.totalMontoCortafuego`]="{ item }">
                S/. {{ new Intl.NumberFormat().format(item.totalMontoCortafuego) }}
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogProyectoDetalle"
          persistent
          max-width="100%"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Detalle de proyectos por usuarios</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-data-table
                    :headers="headersProyectoDetalle"
                    :items="itemsProyectoDetalle"
                  >
                  </v-data-table>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogProyectoDetalle = false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>

<script>

  import firebase from 'firebase/app'

  export default {
    components: {
      Ingreso_Proyectado: () => import('./componentes/IngresoProyectado'),
      Participacion_Contacto: () => import('./componentes/ParticipacionContacto'),
    },
    name: 'DashboardDashboard',
    data () {
      return {
        facturacionProyectada: [],
        dialogProyectoDetalle: false,
        headersDashCantidadEstadoNegociacion: [
          {
            sortable: true,
            text: 'Asesor',
            value: 'asesor',
          },
          {
            sortable: true,
            text: 'Por cotizar',
            value: 'porCotizar',
          },
          {
            sortable: true,
            text: 'Negociación',
            value: 'negociacion',
          },
          {
            sortable: true,
            text: 'Ganado',
            value: 'ganado',
          },
          {
            sortable: true,
            text: 'Perdido',
            value: 'perdido',
          },
          {
            sortable: true,
            text: 'Total',
            value: 'cantidadProyectos',
          },
          {
            sortable: true,
            text: 'Eficacia',
            value: 'eficacia',
          },
        ],
        headersDashIngresoEstadoNegociacion: [
          {
            sortable: true,
            text: 'Asesor',
            value: 'asesor',
          },
          {
            sortable: true,
            text: 'Negociación',
            value: 'totalMontoNegociacion',
          },
          {
            sortable: true,
            text: 'Ganado',
            value: 'totalMontoGanado',
          },
          {
            sortable: true,
            text: 'Perdido',
            value: 'totalMontoPerdido',
          },
          {
            sortable: true,
            text: 'Sub-total',
            value: 'subtotal',
          },
        ],
        headersDashIngresoAsesor: [
          {
            sortable: true,
            text: 'Asesor',
            value: 'asesor',
          },
          {
            sortable: true,
            text: 'Puertas y marcos',
            value: 'totalMontopuertas',
          },
          {
            sortable: true,
            text: 'Cerradura y Bisagra',
            value: 'totalMontoCerraduras',
          },
          {
            sortable: true,
            text: 'Cortafuego y Cerradura',
            value: 'totalMontoCortafuego',
          },
          {
            sortable: false,
            text: 'Detalle',
            value: 'detalle',
          },
          {
            sortable: true,
            text: 'Sub-total',
            value: 'subtotal',
          },
        ],
        items: [],
        headersProyectoDetalle: [
          {
            sortable: true,
            text: 'Inmobiliaria',
            value: 'inmobiliaria',
          },
          {
            sortable: true,
            text: 'Proyecto',
            value: 'proyecto',
          },
          {
            sortable: true,
            text: 'Puertas y marcos',
            value: 'montoPuertas',
          },
          {
            sortable: true,
            text: 'Cerradura y Bisagra',
            value: 'montoCerraduras',
          },
          {
            sortable: true,
            text: 'Cortafuego y Cerradura',
            value: 'montoCortafuego',
          },
          {
            sortable: true,
            text: 'Posibilidad de cierre',
            value: 'posibilidadCierre',
          },
          {
            sortable: true,
            text: 'Estado negociación',
            value: 'estadoNegociacion',
          },
          {
            sortable: true,
            text: 'Fecha facturación',
            value: 'dateFechaFacturacion',
          },
        ],
        itemsProyectoDetalle: [],
      }
    },
    mounted () {
      this.dashboardUno()
    },
    methods: {
      computedEficacia (valor) {
        var respuesta = 0
        if (!isNaN(valor)) {
          respuesta = valor
        }
        return respuesta
      },
      dashboardUno () {
        firebase.firestore().collection('users').where('perfil', '==', 'Vendedor').get().then(vendedores => {
          vendedores.forEach(vendedor => {
            var montoPuertas = 0
            var montoCerraduras = 0
            var montoCortafuego = 0
            var totalMontopuertas = 0
            var totalMontoCerraduras = 0
            var totalMontoCortafuego = 0
            var porCotizar = 0
            var negociacion = 0
            var ganado = 0
            var perdido = 0
            var cantidadProyectos = 0
            var montoPorCotizar = 0
            var totalMontoPorCotizar = 0
            var montoNegociacion = 0
            var totalMontoNegociacion = 0
            var montoGanado = 0
            var totalMontoGanado = 0
            var montoPerdido = 0
            var totalMontoPerdido = 0
            firebase.firestore().collection('proyectos').where('fase', '==', 2).where('asesor', '==', vendedor.data().email).get().then(results => {
              results.forEach(result => {
                cantidadProyectos = cantidadProyectos + 1
                if (result.data().estadoNegociacion === 'POR COTIZAR') {
                  porCotizar = porCotizar + 1
                  montoPorCotizar = parseInt(result.data().montoPuertas) + parseInt(result.data().montoCerraduras) + parseInt(result.data().montoCortafuego)
                  totalMontoPorCotizar = totalMontoPorCotizar + montoPorCotizar
                }
                if (result.data().estadoNegociacion === 'NEGOCIACIÓN') {
                  negociacion = negociacion + 1
                  montoNegociacion = parseInt(result.data().montoPuertas) + parseInt(result.data().montoCerraduras) + parseInt(result.data().montoCortafuego)
                  totalMontoNegociacion = totalMontoNegociacion + montoNegociacion
                  const data = {
                    asesor: vendedor.data().email,
                    fechaFactura: result.data().dateFechaFacturacion,
                    monto: totalMontoNegociacion,
                  }
                  this.facturacionProyectada.push(data)
                }
                if (result.data().estadoNegociacion === 'GANADO') {
                  ganado = ganado + 1
                  montoGanado = parseInt(result.data().montoPuertas) + parseInt(result.data().montoCerraduras) + parseInt(result.data().montoCortafuego)
                  totalMontoGanado = totalMontoGanado + montoGanado
                }
                if (result.data().estadoNegociacion === 'PERDIDO') {
                  perdido = perdido + 1
                  montoPerdido = parseInt(result.data().montoPuertas) + parseInt(result.data().montoCerraduras) + parseInt(result.data().montoCortafuego)
                  totalMontoPerdido = totalMontoPerdido + montoPerdido
                }
                montoPuertas = parseInt(result.data().montoPuertas)
                totalMontopuertas = totalMontopuertas + montoPuertas
                montoCerraduras = parseInt(result.data().montoCerraduras)
                totalMontoCerraduras = totalMontoCerraduras + montoCerraduras
                montoCortafuego = parseInt(result.data().montoCortafuego)
                totalMontoCortafuego = totalMontoCortafuego + montoCortafuego
              })
              this.items.push({
                asesor: vendedor.data().email,
                porCotizar: porCotizar,
                totalMontoPorCotizar: totalMontoPorCotizar,
                negociacion: negociacion,
                totalMontoNegociacion: totalMontoNegociacion,
                ganado: ganado,
                totalMontoGanado: totalMontoGanado,
                perdido: perdido,
                totalMontoPerdido: totalMontoPerdido,
                cantidadProyectos: cantidadProyectos,
                eficacia: ganado / (ganado + perdido) * 100,
                totalMontopuertas: totalMontopuertas,
                totalMontoCerraduras: totalMontoCerraduras,
                totalMontoCortafuego: totalMontoCortafuego,
              })
            })
          })
        })
      },
      complete (index) {
        this.list[index] = !this.list[index]
      },
      openDialogVerDetalle (item) {
        this.dialogProyectoDetalle = true
        this.itemsProyectoDetalle = []
        firebase.firestore().collection('proyectos').where('fase', '==', 2).where('asesor', '==', item.asesor).get().then(proyectos => {
          proyectos.forEach(proyecto => {
            this.itemsProyectoDetalle.push({
              inmobiliaria: proyecto.data().inmobiliaria,
              proyecto: proyecto.data().nombre,
              montoPuertas: new Intl.NumberFormat().format(proyecto.data().montoPuertas),
              montoCerraduras: new Intl.NumberFormat().format(proyecto.data().montoCerraduras),
              montoCortafuego: new Intl.NumberFormat().format(proyecto.data().montoCortafuego),
              posibilidadCierre: proyecto.data().posibilidadCierre,
              estadoNegociacion: proyecto.data().estadoNegociacion,
              dateFechaFacturacion: proyecto.data().dateFechaFacturacion,
            })
          })
        })
      },
    },
  }
</script>
